import { createAction } from "@reduxjs/toolkit";
import { dashboardService } from "@/redux/services/dashboardService";
import { loanSummaryService } from "@/features/LoanSummary/Management/store/services/loanSummaryService";
import { accountService } from "@/modules/account/store/services/account-service";
import { connexService } from "@/modules/contacts/features/lender/features/out-of-network/store/connex-service";
import { CONNEX_SERVICE_TAG } from "@/modules/contacts/features/lender/features/out-of-network/utils/connex-service-tags";
import { lenderService as contactLenderService } from "@/modules/contacts/features/lender/store/services/lender-service";
import {
  LENDER_SERVICE_TAG,
  LENDER_LOAN_BEST_MATCH_HEATMAP_SERVICE_TAG,
  LENDER_LOANS_HEATMAP_SERVICE_TAG,
} from "@/modules/contacts/features/lender/utils/lender-service-tags";
import {
  LENDER_BOARD_REDUCER_PATH,
  LENDER_BOARD_SERVICE_TAG,
} from "@/features/LenderBoard/Management/utils/lender-board-service-tags";

const invalidateLenderBoardTags = createAction(`${LENDER_BOARD_REDUCER_PATH}/invalidateTags`);

/**
 * Invalidates all cross-service caches that depend on loan data.
 * Used by addLoan, patchLoan, and deleteLoan onQueryStarted callbacks.
 *
 * @param {Function} dispatch - Redux dispatch
 * @param {Object} [options]
 * @param {boolean} [options.includeLoanSummary] - Also invalidate LoanSummary tags
 */
export function invalidateRelatedCaches(dispatch, { includeLoanSummary = false } = {}) {
  dispatch(
    dashboardService.util.invalidateTags([
      "Dashboard.Summary",
      "Dashboard.FilesActivity",
      "Dashboard.OutstandingNeedsList",
      "Dashboard.ReviewNeedsList",
    ]),
  );
  dispatch(accountService.endpoints.refreshCompanyLoanCount.initiate(undefined, { forceRefetch: true }));
  dispatch(connexService.util.invalidateTags([CONNEX_SERVICE_TAG]));
  dispatch(
    contactLenderService.util.invalidateTags([
      LENDER_SERVICE_TAG,
      LENDER_LOAN_BEST_MATCH_HEATMAP_SERVICE_TAG,
      LENDER_LOANS_HEATMAP_SERVICE_TAG,
    ]),
  );
  dispatch(invalidateLenderBoardTags([LENDER_BOARD_SERVICE_TAG]));

  if (includeLoanSummary) {
    dispatch(loanSummaryService.util.invalidateTags(["LoanSummary"]));
  }
}

